<template>
  <div class="supervisor-reservation" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="预约监理" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="content-form">
      <div v-if="isOffer == '1'" class="appointment-form-item border-bottom-style">
        <div class="form-title">服务类型</div>
        <div>凯哥看报价</div>
      </div>
      <div class="appointment-form-item border-bottom-style">
        <div class="form-title">联系人</div>
        <input class="form-input" type="text" v-model="appointment.name" placeholder="请输入联系人"/>
        <div class="form-input-box-sex">
          <div class="sex-radio" @click="selectSex(1)">
            <img v-if="sex == 1" src="../../assets/icon/icon-check-box-selected.png">
            <img v-if="sex != 1" src="../../assets/icon/icon-check-box-unselect.png">男
          </div>
          <div class="sex-radio" @click="selectSex(0)">
            <img v-if="sex == 0" src="../../assets/icon/icon-check-box-selected.png">
            <img v-if="sex != 0" src="../../assets/icon/icon-check-box-unselect.png">女
          </div>
        </div>
      </div>
      <div v-if="deposit && deposit>0" class="appointment-form-item border-bottom-style">
        <div class="form-title">订金</div>
        <div class="appointment-deposit"><span class="unit">￥</span><span class="num">{{deposit}}</span></div>
      </div>
      <div v-if="isOffer != '1'">
        <div class="appointment-form-item border-bottom-style" @click="selectHouseType()">
          <div class="form-title">户型</div>
          <input class="form-input" readonly type="text" v-model="houseTypeShow" placeholder="选择户型"/>
          <img class="icon-form-select" src="../../assets/icon/icon-drop-down.png">
        </div>
        <div class="appointment-form-item border-bottom-style" @click="selectArea()">
          <div class="form-title">区域</div>
          <input class="form-input" readonly type="text" v-model="areaName" placeholder="选择区域"/>
          <img class="icon-form-select" src="../../assets/icon/icon-drop-down.png">
        </div>
        <div class="appointment-form-item border-bottom-style" @click="selectHouseState()">
          <div class="form-title">房屋类型</div>
          <input class="form-input" type="text" readonly v-model="houseStateShow" placeholder="选择房屋类型"/>
          <img class="icon-form-select" src="../../assets/icon/icon-drop-down.png">
        </div>
        <div class="appointment-form-item border-bottom-style">
          <div class="form-title">面积</div>
          <input class="form-input" type="number" v-model="appointment.houseArea" placeholder="请输入平方数"/>
          <div class="form-unit">平米</div>
        </div>
        <div class="appointment-form-item border-bottom-style">
          <div class="form-title">小区</div>
          <input class="form-input" type="text" v-model="appointment.village" placeholder="请输入小区名称"/>
        </div>
      </div>
      <div class="appointment-form-item border-bottom-style">
        <div class="form-title">手机号</div>
        <input class="form-input" type="number" v-model="appointment.phone" placeholder="请输入手机号"/>
      </div>
      <div class="appointment-submit-btn" :class="{'wait-res': waitRes}" @click="checkAppointment()">提交</div>
    </div>
    <!--已预约是否再次预约的提示框-->
    <div v-if="alertCheck" class="toast general-tip-modal">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="cancelAlert()">
      <div class="general-modal-title border-bottom-style">温馨提示</div>
      <div class="general-modal-msg">已预约，您要再次预约吗？</div>
      <div class="agree-btn" @click="confirmAlert()">再次预约</div>
    </div>
    <div v-if="alertCheck" class="pay-box"></div>
    <div v-if="alertSuccess" class="toast general-tip-modal">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="goback()">
      <div class="general-modal-title border-bottom-style">温馨提示</div>
      <div class="general-modal-msg">预约成功！</div>
      <div class="agree-btn" @click="openAppointmentDetail()">预约详情</div>
    </div>
    <div v-if="alertSuccess" class="pay-box"></div>
    <div v-if="showSelectArea" class="toast appointment-select-part">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="confirmSelectArea">
      <div class="select-title" @click="confirmSelectArea">请选择区域</div>
      <div class="appointment-area-select-list">
        <div v-for="area in areaList" @click="selectAppointmentArea(area.value,area.text)"  class="select-item" :class="{selected: area.value == areaId,disable:area.disabled}">{{area.text}}</div>
      </div>
    </div>

    <div v-if="showSelectHouseState" class="toast appointment-select-part">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="confirmSelectHouseState">
      <div class="select-title" @click="confirmSelectHouseState">请选择房屋类型</div>
      <div class="appointment-area-select-list">
        <div v-for="houseStateItem in houseStateList" @click="selectAppointmentHouseState(houseStateItem.value,houseStateItem.text)"  class="select-item" :class="{selected: houseStateItem.value === houseState}">{{houseStateItem.text}}</div>
      </div>
    </div>
    <div v-if="showSelectHouseState" class="pay-box"></div>

    <div v-if="showSelectArea" class="pay-box"></div>
    <div v-if="showSelectHouseType" class="toast appointment-select-part">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="confirmSelectHouseType">
      <div class="select-title" @click="confirmSelectHouseType">请选择户型</div>
      <div class="appointment-select-list">
        <div class="appointment-select-group">
          <div v-for="roomType in roomTypeList" class="select-item" :class="{selected: roomType.value == room}" @click="selectRoom(roomType.value,roomType.showText)">{{roomType.text}}</div>
        </div>
        <div class="appointment-select-group">
          <div v-for="parlourType in parlourTypeList" class="select-item" :class="{selected: parlourType.value == parlour}" @click="selectParlour(parlourType.value,parlourType.showText)">{{parlourType.text}}</div>
        </div>
        <div class="appointment-select-group">
          <div v-for="toiletType in toiletTypeList" class="select-item" :class="{selected: toiletType.value == toilet}" @click="selectToilet(toiletType.value,toiletType.showText)">{{toiletType.text}}</div>
        </div>
        <div class="appointment-select-group">
          <div v-for="kitchenType in kitchenTypeList" class="select-item" :class="{selected: kitchenType.value == kitchen}" @click="selectKitchen(kitchenType.value,kitchenType.showText)">{{kitchenType.text}}</div>
        </div>
      </div>
    </div>
    <div v-if="showSelectHouseType" class="pay-box"></div>

    <!--温馨提示 -->
    <div v-if="preAppointmentToast" class="toast appointment-reminder">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="closeAppointmentReminder">
      <div class="title">温馨提示</div>
      <div class="reminder-content">
        <div>一旦生成项目</div>
        <div>订金不予退还!</div>
        <div>为您造成的不便敬请谅解!</div>
      </div>
      <div class="agree-btn" @click = "prePayAppointment">确定</div>
    </div>
    <div v-if="preAppointmentToast" class="pay-box"></div>

    <!--预约温馨提示-->
    <div v-if="showConfirmPayTip" class="toast general-tip-modal">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="closePayTip()">
      <div class="general-modal-title border-bottom-style">温馨提示</div>
      <div class="reminder-content">
        <div>支付完成后</div>
        <div>请点击我已付款按钮!</div>
        <div>如有问题请联系客服!  电话：4000600566</div>
      </div>
      <div class="agree-btn" @click="closeConfirmPayTip()">我已付款</div>
    </div>
    <div v-if="showConfirmPayTip" class="pay-box"></div>
  </div>
</template>

<script>
  import {imgUrl,shareIcon} from '../../config'
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import session from '../../utils/Session'
  import AppointmentService from '../../service/customer/AppointmentService'
  import supervisorAreaService from '../../service/onestop/OnestopSupervisorAreaService'
  import AreaService from '../../service/core/AreaService'
  import SupervisorService from '../../service/SupervisorService'
  import shareService from '../../service/share/ShareService'
  import payUtil from '../../utils/Pay'

  export default {
    name: 'SupervisorReservation',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        sex:1,
        areaId:'',
        areaName:'',
        room:'',
        roomShowText:'',
        parlour:'',
        parlourShowText:'',
        toilet:'',
        toiletShowText:'',
        kitchen:'',
        kitchenShowText:'',
        areaList:[{value:0,text:'请选择',disabled:false}],
        roomTypeList:[{value:1,text:'一室',showText:'一室'},{value:2,text:'两室',showText:'两室'},{value:3,text:'三室',showText:'三室'},{value:4,text:'四室',showText:'四室'},{value:5,text:'五室',showText:'五室'}],
        parlourTypeList:[{value:1,text:'一厅',showText:'一厅'},{value:2,text:'两厅',showText:'两厅'},{value:3,text:'三厅',showText:'三厅'},{value:4,text:'四厅',showText:'四厅'},{value:5,text:'五厅',showText:'五厅'}],
        toiletTypeList:[{value:1,text:'一卫',showText:'一卫'},{value:2,text:'两卫',showText:'两卫'},{value:3,text:'三卫',showText:'三卫'},{value:4,text:'四卫',showText:'四卫'},{value:5,text:'五卫',showText:'五卫'}],
        kitchenTypeList:[{value:1,text:'一厨',showText:'一厨'},{value:2,text:'两厨',showText:'两厨'},{value:3,text:'三厨',showText:'三厨'},{value:4,text:'四厨',showText:'四厨'},{value:5,text:'五厨',showText:'五厨'}],
        houseTypeShow:'',
        appointment:{phone:''},
        alertCheck:false,
        alertSuccess:false,
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        isWechatBrowser:this.$verfyBrowserType(),
        showSelectArea:false,
        showSelectHouseType:false,
        showOtherHouseType:false,
        supervisorName:'',
        appointmentId:'',
        supervisor:'',
        showSelectHouseState:false,
        houseStateList:[{value:0,text:'旧房'},{value:1,text:'新房'}],
        houseStateShow:'',
        houseState:'',
        supervisorAreaList:[],
        prePayInfo:{},
        tradeAppointmentId:'',
        deposit:'',
        preAppointmentToast:false,
        serviceType:'',
        isOffer:'0',
        waitRes:false,
        showConfirmPayTip:false,
      }
    },
    created(){
      this.supervisorName = this.$route.query.supervisorName;
      this.appointment.supervisorId =this.$route.query.id;
      this.deposit = this.$route.query.deposit;
      this.isOffer = this.$route.query.isOffer || '0';
      if(this.isOffer == '1'){
        this.serviceType = '3';
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.initWechatShare();
      this.getSupervisorAreaList();
    },

    methods: {
      selectSex(sex){
        this.sex = sex;
      },
      async getAreaList(cityId){
        this.areaList = [];
        var result=await AreaService.getAreaList(cityId);
        if(result.code == 0){
          var areas = result.data;
          var that = this;
          $(areas).each(function () {
            this.disabled = true;
            this.value=this.id;
            this.text=this.name;
            for (let supervisorArea of that.supervisorAreaList){
              if(supervisorArea.areaId == this.id){
                this.disabled = false
              }
            }
            that.areaList.push(this);
          });
        }else {
          Toast('获取城市区域列表信息失败');
        }
      },
      async getSupervisorAreaList(){
        var result = await supervisorAreaService.list(this.appointment.supervisorId);
        if(result.code == 0){
          this.supervisorAreaList = result.data;
          this.getAreaList('2');
        }else {
          Toast('获取监理接单区域信息失败');
        }
      },
      /**
       * 验证手机号码（移动电话）
       */
      mobilePhone(){
        var phone = this.appointment.phone;
        if (phone == '') {
          Toast('请输入手机号码！');
          return false;
        }
        var re= /^1[3578]\d{9}$/;
        if(re.test(phone)){
          return true;
        } else {
          Toast('手机号码格式不正确!');
          return false;
        }
      },
      async checkAppointment(){
          var result = await SupervisorService.getSupervisorDetail(this.appointment.supervisorId);
          if (result.code == 0) {
            this.supervisor = result.data;
            if (this.supervisor.appointmentSwitch != '1') {
              Toast('该监理暂时不接受预约!');
              return;
            } else if (this.supervisor.appointmentSwitch == '1' && this.supervisor.spares == 0) {
              Toast('该监理预约已满!');
              return;
            }
          } else {
            Toast('预约失败!');
            return
          }

          if (this.appointment.name == null || this.appointment.name == '') {
            Toast('请填写联系人姓名！');
            return;
          }
          if(this.isOffer != '1'){
            if (this.room == '' || this.parlour == '') {
              Toast('请完善您的户型信息!');
              return;
            }
            if (this.areaId == '') {
              Toast('请选择区域！');
              return;
            } else {
              let areaSelect = false;
              for (let supervisorArea of this.supervisorAreaList) {
                if (this.areaId == supervisorArea.areaId) {
                  areaSelect = true;
                }
              }
              if (!areaSelect) {
                Toast('对不起!您选择的区域不在该监理接单范围!');
                return;
              } else {
                this.appointment.cityId = 2;
                this.appointment.areaId = this.areaId;
              }
            }
            if (this.houseState === '') {
              Toast('请选择房屋类型！');
              return;
            }
            if (this.appointment.houseArea == null || this.appointment.houseArea == '') {
              Toast('请填写住房面积！');
              return;
            }
            if (this.appointment.village == null || this.appointment.village == '') {
              Toast('请填写小区名称！');
              return;
            }
          }
          if (!this.mobilePhone()) {
            return;
          }
          this.appointment.type = 1;
          this.appointment.sex = this.sex;
          this.appointment.serviceType = this.serviceType;
          this.appointment.room = this.room;
          this.appointment.houseType = this.houseState;
          this.appointment.parlour = this.parlour;
          this.appointment.toilet = this.toilet;
          this.appointment.kitchen = this.kitchen;
          this.appointment.customerId = session.getAccountToken().id == undefined ? '' : session.getAccountToken().id;
          var res = await AppointmentService.checkAppointment(this.appointment);
          if (res.code == '0') {
            if (res.data == '1') {
              if (this.supervisor.deposit && this.supervisor.deposit > 0) {
                this.preAppointmentToast = true;
              } else {
                this.appointment.isDeposited = '0';
                this.createAppointment();
              }

            } else {
              this.alertCheck = true;
            }
          } else {
            Toast('预约失败，请稍后再试！');
          }
      },

      async prePayAppointment(){
        this.waitRes = false;
        this.preAppointmentToast = false;
        let prepayResult = await AppointmentService.prePayAppointment(this.appointment,this.supervisor.deposit);
        if(prepayResult.code == '0'){
          this.tradeAppointmentId = prepayResult.data.tradeAppointmentId;
          //判断用户使用环境
          let ua = navigator.userAgent.toLowerCase();
          if(ua.match(/newsmthApp/i) == 'newsmthapp'){
              //水木社区app
              window.location.href = 'bridgescheme://request_shuimuPay?prepayId=' + prepayResult.data.prepayId;
              //弹出提示业主查询支付结果弹窗
              this.showConfirmPayTip = true;
          }else {
              //微信中调用微信支付
              this.prePayInfo = payUtil.pay(prepayResult.data.prepayId,prepayResult.data.nonceStr);
              let requestPay = this.requestPay;
              if (typeof WeixinJSBridge == "undefined"){
                  if( document.addEventListener ){
                      document.addEventListener('WeixinJSBridgeReady', requestPay.bind(this), false);
                  }else if (document.attachEvent){
                      document.attachEvent('WeixinJSBridgeReady', requestPay.bind(this));
                      document.attachEvent('onWeixinJSBridgeReady', requestPay.bind(this));
                  }
              }else{
                  this.requestPay();
              }
          }
        } else {
          Toast(prepayResult.msg);
        }
      },
      closeAppointmentReminder(){
        this.waitRes = false;
        this.preAppointmentToast = false;
      },
      selectArea(){
        this.showSelectArea = true;
      },
      closeSelectArea(){
        this.showSelectArea = false;
      },
      selectAppointmentArea(areaId,areaName){
        this.areaId = areaId;
        this.areaName = areaName;
      },
      confirmSelectArea(){
        this.showSelectArea = false;
        if(this.areaId){
          let areaSelect = false;
          for (let supervisorArea of this.supervisorAreaList){
            if(this.areaId == supervisorArea.areaId){
              areaSelect = true;
            }
          }
          if(!areaSelect){
            Toast('对不起!您选择的区域不在该监理接单范围!');
          }
        }
      },
      selectHouseState(){
        this.showSelectHouseState = true;
      },
      selectAppointmentHouseState(houseState,houseStateShow){
        this.houseState = houseState;
        this.houseStateShow = houseStateShow;
      },
      confirmSelectHouseState(){
        this.showSelectHouseState = false;
      },
      selectHouseType(){
        this.showSelectHouseType = true;
      },
      confirmSelectHouseType(){
        this.houseTypeShow = this.roomShowText + this.parlourShowText + this.toiletShowText + this.kitchenShowText;
        this.showSelectHouseType = false;
      },
      selectRoom(room,showText){
        if(this.room != room){
          this.roomShowText = showText;
          this.room = room;
        } else {
          this.roomShowText = '';
          this.room = '';
        }
      },
      selectParlour(parlour,showText){
        if(this.parlour != parlour){
          this.parlourShowText = showText;
          this.parlour = parlour;
        } else {
          this.parlourShowText = '';
          this.parlour = '';
        }
      },
      selectToilet(toilet,showText){
        if(this.toilet != toilet){
          this.toiletShowText = showText;
          this.toilet = toilet;
        } else {
          this.toiletShowText = '';
          this.toilet = '';
        }
      },
      selectKitchen(kitchen,showText){
        if(this.kitchen != kitchen){
          this.kitchenShowText = showText;
          this.kitchen = kitchen;
        } else {
          this.kitchenShowText = '';
          this.kitchen = '';
        }
      },
      cancelAlert(){
        this.alertCheck = false;
      },
      async confirmAlert(){
        this.alertCheck = false;
        if(this.supervisor.deposit && this.supervisor.deposit>0){
          this.preAppointmentToast = true;
        }else {
          this.appointment.isDeposited = '0';
          this.createAppointment();
        }
      },
      goback () {
        this.$router.go(-1);
      },
      openAppointmentDetail(){
        this.$router.push({name:'AppointmentDetail',query:{id:this.appointmentId}});
      },
      async createAppointment(){
        var result = await AppointmentService.createAppointment(this.appointment);
        if(result.code == '0'){
          this.appointmentId = result.data.id;
          this.alertSuccess = true;
        }else {
          Toast('预约失败');
        }
        this.waitRes = false;
      },
      DetailSupervisor(supervisor){
        this.$router.push({name:'SupervisorDetail',query:{supervisorId:supervisor.id}});
      },

      async initWechatShare(){
        let title = "水木家居商城监理预约入口——"+this.supervisorName;// 分享标题
        let desc = ""; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
      requestPay(){
        let prePayInfo = this.prePayInfo;
        let that = this;
        try {
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            {
              "appId":prePayInfo.appId,     //公众号名称，由商户传入
              "timeStamp":prePayInfo.timeStamp,         //时间戳，自1970年以来的秒数
              "nonceStr":prePayInfo.nonceStr, //随机串
              "package":prePayInfo.package,
              "signType":prePayInfo.signType,         //微信签名方式：
              "paySign":prePayInfo.paySign //微信签名
            },
            function(res){
              that.preAppointmentToast = false;
              if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                that.appointment.tradeAppointmentId = that.tradeAppointmentId;
                that.appointment.isDeposited = 1;
                that.createAppointment();
              } else if(res.err_msg == "get_brand_wcpay_request:cancel" ){
                console.info("取消支付");
              }else {
                Toast('支付失败!');
                that.errorMsg = JSON.stringify(res)
              }// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
            },function (e) {
              Toast("支付失败!"+JSON.stringify(e));
            });
        }catch (e){
          Toast("支付失败!"+JSON.stringify(e));
        }
      },
      async closeConfirmPayTip(){
          let result = await AppointmentService.checkPaymentStatus(this.tradeAppointmentId);
          if(result.code == '0'){
              this.appointment.tradeAppointmentId = this.tradeAppointmentId;
              this.appointment.isDeposited = 1;
              this.showConfirmPayTip = false;
              this.createAppointment();
          }else {
              Toast('请联系客服确认订单支付结果!');
          }
      },
      async closePayTip(){
          this.showConfirmPayTip = false;
          let result = await AppointmentService.checkPaymentStatus(this.tradeAppointmentId);
          if(result.code == '0'){
              this.appointment.tradeAppointmentId = this.tradeAppointmentId;
              this.appointment.isDeposited = 1;
              this.createAppointment();
          }else {
              Toast('请联系客服确认订单支付结果!');
          }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/style/common.scss';
  @import '../../assets/style/supervisor-appointment.scss';
</style>

